import { createContext, useContext, useState } from "react";

const DemoModalContext = createContext({ open: false, setOpen: () => {} });

export const DemoModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <DemoModalContext.Provider value={{ open, setOpen }}>
      {children}
    </DemoModalContext.Provider>
  );
};

export const useDemoModal = () => useContext(DemoModalContext);
